import { Store, applyMiddleware, combineReducers, createStore } from 'redux';
import {
	handleCacheStore,
	mergeWithCachedStore,
	reducers as sharedReducers,
	sagas as sharedSagas,
	whiteListReducers as sharedWhitelistReducers,
} from '@innovyze/stylovyze';
import libAmCommon, {
	reducerWhiteList as amReducerWhiteList,
} from '@innovyze/lib-am-common/Reducers';
import {
	moduleNamespace as mapUiNamespace,
	reducers as mapUiReducers,
	sagas as mapUiSagas,
} from '@innovyze/map-components';

import { all } from 'redux-saga/effects';
// eslint-disable-next-line import/no-unresolved
import appAmAssetUpload from 'fed_app_am_data_management/Reducers';
// eslint-disable-next-line import/no-unresolved
import assetUploadSaga from 'fed_app_am_data_management/Sagas';
import appAmAssets from '@innovyze/app-am-network/Reducers';
import appAmInspections from '@innovyze/app-am-activities/Reducers';
import appAmRehabDecisionDashboard from '@innovyze/app-am-rehab/Reducers';
import appAmRisk from '@innovyze/app-am-risk/Reducers';
import assetsSaga from '@innovyze/app-am-network/Sagas';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
// eslint-disable-next-line import/no-unresolved
import entitlements from 'fed_admin/Reducers';
// eslint-disable-next-line import/no-unresolved
import entitlementsSaga from 'fed_admin/Sagas';
import inspectionsSaga from '@innovyze/app-am-activities/Sagas';
import libAmCommonSaga from '@innovyze/lib-am-common/Sagas';
import { reducerWhiteList } from '@innovyze/app-am-network/Reducers';
import rehabSaga from '@innovyze/app-am-rehab/Sagas';
import riskSaga from '@innovyze/app-am-risk/Sagas';
import thunk from 'redux-thunk';
import mercury from '@innovyze/mercury-fe/Reducers';
import venus from '@innovyze/venus-fe/Reducers';
import { reducerKey as mercuryKey } from '@innovyze/mercury-fe/Reducers';
import mercurySaga from '@innovyze/mercury-fe/Sagas';
import venusSaga from '@innovyze/venus-fe/Sagas';

//TODO : When adding a new module add the Reducers and Sagas here
import {
	assetSchemaRootReducer,
	assetSchemaRootSaga,
} from '@innovyze/lib_asset_schema_store';

declare global {
	interface Window {
		store: Store;
		Cypress: object;
	}
}

//TODO : Add the new reducer here
const reducers = combineReducers({
	...sharedReducers,
	entitlements,
	appAmAssets,
	appAmAssetUpload,
	appAmRisk,
	appAmInspections,
	appAmRehabDecisionDashboard,
	[mercuryKey]: mercury,
	venus: venus,
	libAmCommon,
	[mapUiNamespace]: mapUiReducers,
	...assetSchemaRootReducer,
});

const sagaMiddleware = createSagaMiddleware();

const store: Store = createStore(
	reducers,
	mergeWithCachedStore(),
	composeWithDevTools(applyMiddleware(thunk, sagaMiddleware)),
);

store.subscribe(() => {
	const currentState = store.getState();
	handleCacheStore(currentState, [
		...reducerWhiteList,
		// temporarily removed as there is an issue with the handleCacheStore function
		// as it does not correctly merge the cached state with the current state
		// if you are only caching a subset of the state
		// ...amReducerWhiteList,
		...sharedWhitelistReducers,
	]);
});

//TODO : Add the new saga here
const masterRootSaga = function*() {
	yield all([
		sharedSagas(),
		entitlementsSaga(),
		assetsSaga(),
		riskSaga(),
		inspectionsSaga(),
		rehabSaga(),
		assetSchemaRootSaga(),
		libAmCommonSaga(),
		mapUiSagas(),
		assetUploadSaga(),
		mercurySaga(),
		venusSaga(),
	]);
};

sagaMiddleware.run(masterRootSaga);

if (window.Cypress) {
	window.store = window.store || {};
	window.store = store;
}

export default store;
